import { render, staticRenderFns } from "./SimpleOverlayCustomizer.vue?vue&type=template&id=15a4b8e8&scoped=true"
import script from "./SimpleOverlayCustomizer.vue?vue&type=script&lang=js"
export * from "./SimpleOverlayCustomizer.vue?vue&type=script&lang=js"
import style0 from "./SimpleOverlayCustomizer.vue?vue&type=style&index=0&id=15a4b8e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a4b8e8",
  null
  
)

export default component.exports